import { render, staticRenderFns } from "./ShowPerformance.vue?vue&type=template&id=391bb8be"
import script from "./ShowPerformance.vue?vue&type=script&lang=js"
export * from "./ShowPerformance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports